import React from 'react';

const TeachersContext = React.createContext();

export default TeachersContext;